module.exports = __webpack_public_path__ + "static/subscription10-68a55bfd70aa93e8e4164a9653e9e50f.jpg";